/**
 * ProPresenter library name validation (T042 contract §2.5).
 *
 * Mirrors the Media Station and n8n checks exactly. Client-side validation is
 * UX only — the Media Station is the enforcement point and re-validates both
 * syntactically and against the library folders that exist on disk.
 */

export const LIBRARY_NAME_MAX = 64;

const LIBRARY_NAME_RE = /^(?![ .])(?!.*[ .]$)[^\\/:*?"<>|\x00-\x1f\x7f]{1,64}$/;
const RESERVED = /^(con|prn|aux|nul|com[1-9]|lpt[1-9]|librarydata|\.|\.\.)$/i;

export const isValidLibraryName = (s) =>
  typeof s === 'string' && LIBRARY_NAME_RE.test(s.normalize('NFC')) && !RESERVED.test(s);

/**
 * Human-readable reason a name is rejected, or null when it is valid.
 * Only used for the inline error; `isValidLibraryName` is the rule.
 *
 * @param {string} s
 * @returns {string|null}
 */
export const libraryNameError = (s) => {
  if (isValidLibraryName(s)) return null;
  if (typeof s !== 'string' || s.length === 0) return 'Enter a library name.';
  if (s.length > LIBRARY_NAME_MAX) return `Library names can be at most ${LIBRARY_NAME_MAX} characters.`;
  if (/^librarydata$/i.test(s)) return 'LibraryData is ProPresenter\'s own data folder, not a library.';
  if (/[\\/]/.test(s) || /^\.{1,2}$/.test(s)) return 'Enter a library name, not a folder path.';
  if (/^[ .]|[ .]$/.test(s)) return 'Library names can\'t start or end with a space or a dot.';
  if (RESERVED.test(s)) return `"${s}" is a reserved name on Windows.`;
  return 'Library names can\'t contain : * ? " < > | or control characters.';
};
